module.exports = __webpack_public_path__ + "static/media/icon-bookings.651db802.svg";